import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a629b62")

_pushScopeId("data-v-0a629b62")
const _hoisted_1 = { class: "ml-3 bg-transparent h-7 block text-left text-lg font-medium text-gray-300" }
const _hoisted_2 = {
  class: "mb-4 mt-0 flex rounded-2xl bg-gray-200 dark:bg-gray-700 pt-1.5 justify-center grid-cols-2",
  title: "channels"
}
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = { class: "mx-auto" }
const _hoisted_5 = { class: "h-12 w-full -mt-2 mb-4 rounded-2xl bg-gray-200 dark:bg-gray-700" }
const _hoisted_6 = { class: "pb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "follow the next step", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MailChannel = _resolveComponent("MailChannel")
  const _component_TelegramChannel = _resolveComponent("TelegramChannel")
  const _component_input_field_no_label = _resolveComponent("input-field-no-label")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("label", _hoisted_1, _toDisplayString(_ctx.inputPlaceholder), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_MailChannel, {
          "default-email": _ctx.defaultEmail,
          onShowLoading: _ctx.showLoading,
          onHideLoading: _ctx.hideLoading,
          onInputSubmit: _ctx.inputSubmit,
          onUpdateEmail: _ctx.updateEmail,
          onUpdateSelectedChannel: _ctx.updateSelectedChannel,
          "channel-selected": _ctx.isMailChannelSelected()
        }, null, 8, ["default-email", "onShowLoading", "onHideLoading", "onInputSubmit", "onUpdateEmail", "onUpdateSelectedChannel", "channel-selected"]), [
          [_vShow, _ctx.isMailChannelSelected()]
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_TelegramChannel, {
          onUpdateSelectedChannel: _ctx.updateSelectedChannel,
          "channel-selected": _ctx.isTelegramChannelSelected()
        }, null, 8, ["onUpdateSelectedChannel", "channel-selected"]), [
          [_vShow, _ctx.isTelegramChannelSelected()]
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_5, [
      _createVNode(_component_input_field_no_label, {
        value: _ctx.emailForChannel,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.emailForChannel = $event)),
        "input-placeholder": _ctx.$t('share.CardShare.shareMailPlaceholder'),
        onKeydown: _withKeys(_ctx.inputSubmit, ["enter"]),
        onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateEmail(_ctx.emailForChannel))),
        "css-class": "m-0 ml-1 mr-2",
        "input-type": "email",
        "required-field": "true",
        "autocomplete-input": "true",
        "i-height": "h-12",
        "i-width": "w-full",
        "input-id": "Mail"
      }, null, 8, ["value", "input-placeholder", "onKeydown"])
    ], 512), [
      [_vShow, _ctx.isMailChannelSelected()]
    ]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _hoisted_7
    ], 512), [
      [_vShow, _ctx.isTelegramChannelSelected()]
    ]),
    _hoisted_8
  ], 64))
})